import React from "react";
import "../../Components/Menu/Menu.css";

export default function Purpose() {
  return (
    <div>
      <h4 className="sub-title">Brukerkonto, identifisering og sikkerhet </h4>
      <p className="content">
        For å ta i bruk Bilista må du identifisere deg. Det gjør du med BankID.
        Når du har logget inn med BankID, forblir du logget inn selv om du
        lukker appen. Hvis du ønsker å logge ut, kan du aktivt logge ut i appen,
        eller slette appen.
      </p>
    </div>
  );
}
